<template>
    <svg
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
            d="M20.6923 15.4999C21.1679 15.4999 21.5881 15.3175 21.9527 14.9526C22.3176 14.588 22.5 14.1678 22.5 13.6921V12.0769C22.5 11.9719 22.4865 11.8594 22.4595 11.7394C22.4327 11.6196 22.4026 11.5076 22.3693 11.4036L19.5033 4.64114C19.3601 4.32131 19.1199 4.05114 18.7828 3.83064C18.4456 3.61014 18.0938 3.49989 17.7273 3.49989H7.2115V15.4999L13.0288 21.2671C13.2276 21.4658 13.4578 21.5844 13.7193 21.6229C13.9808 21.6614 14.2313 21.6166 14.471 21.4884C14.7108 21.3601 14.8865 21.178 14.998 20.9421C15.1095 20.7063 15.1333 20.4621 15.0693 20.2094L13.9923 15.4999H20.6923ZM8.7115 14.8614V4.99989H17.7308C17.8012 4.99989 17.8733 5.01914 17.947 5.05764C18.0208 5.09614 18.077 5.16022 18.1155 5.24989L21 11.9999V13.6921C21 13.782 20.9712 13.8557 20.9135 13.9134C20.8558 13.9711 20.7821 13.9999 20.6923 13.9999H12.0963L13.35 19.4806L8.7115 14.8614ZM4.30775 3.49989C3.81058 3.49989 3.385 3.67689 3.031 4.03089C2.677 4.38489 2.5 4.81047 2.5 5.30764V13.6921C2.5 14.1893 2.677 14.6149 3.031 14.9689C3.385 15.3229 3.81058 15.4999 4.30775 15.4999H7.2115V13.9999H4.30775C4.21792 13.9999 4.14417 13.9711 4.0865 13.9134C4.02883 13.8557 4 13.782 4 13.6921V5.30764C4 5.21781 4.02883 5.14406 4.0865 5.08639C4.14417 5.02872 4.21792 4.99989 4.30775 4.99989H7.2115V3.49989H4.30775Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
